import React, { useState } from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import DeliveryModal from './DeliveryModal'
import {
  hero,
  heroText,
  mobileHero,
  mobileHeroText,
  deliveryButton,
} from 'images'

export default () => {
  const [showModal, setShowModal] = useState(false)
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="105VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyStart
        >
          <CFView textCenter justifyStart w="100%" h="90vh">
            <CFView column center mt="25px">
              <CFImage src={mobileHeroText} w="45%" alt="Promotions" />
            </CFView>
            <CFView mt="30px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
          pl="3%"
        >
          <CFImage w="43%" src={heroText} alt="Promotions" />
          <CFView mt="30px" ml="30px" pulsate>
            <OrderPickupButton />
          </CFView>
        </CFView>
      </DefaultScreen>
      <DeliveryModal
        showModal={showModal}
        onRequestClose={() => setShowModal(false)}
      />
    </CFView>
  )
}
